/* eslint-disable array-callback-return */
import React from 'react';
import { BaSeBackendNoSignalPage, BaSeDialogContext, BaSeIcon, BaSeInput, BaSeTheme } from '@base/react';
import FuncionalidadeModel from './funcionalidades.model';
import Spinner from 'react-spinner-material';
import './style.scss';
// import {
//   // FaCheck,
//   // FaPen,
//   // FaTrash,
//   FaArrowCircleLeft,
//   FaArrowCircleRight,
//   // FaCopy,
// } from "react-icons/fa";
import { IoIosArrowDropleft as FaArrowCircleLeft, IoIosArrowDropright as FaArrowCircleRight, } from 'react-icons/io';
// import { FaRegCheckCircle as FaCheck } from 'react-icons/fa';
// import { TiEdit as FaPen } from 'react-icons/ti';
import logoFuncionalidades from '../../images/logoFuncionalidades.png';
// import IconReorder from '../../images/Reorder.png';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import download from '../../images/download.png';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import ReactExport from 'react-export-excel';
import columns from './columns';
import { AddFuncionalidade } from './addFuncionalidade/addFuncionalidade';
import { ReorderFuncionalidades } from './reoderFuncionalidades/reorderFuncionalidades';
import { formatDefaultValueSelect } from '../../utils/mask';
import { formatDateToBR } from '../../utils/time';

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const optionsLinesPorPage = [10, 25, 50, 100];

export const DEFAULT_VALUE_SELECIONE = 'Todos';

const Funcionalidades = () => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const {
    data,
    // currentData,
    isLoading,
    error,
    typeScreen,
    setTypeScreen,
    filters,
    setFilters,
    selectedRow,
    setSelectedRow,
    allValuesOptions,
    setAllValuesOptions,
    filtersSelectedValues,
    updateSelectedValues,
    deleteFuncionalidade,
    setActionDone,
    updateStatusFuncionalidade,
    filterOptions,
    getCidades,
    cidades,
    cleanSelectedFilters,
    // time,
    downloadingSheet,
    downloadedSheet,
    downloadFile,
    // trateExcelData,
    // tratedCols,
    aprovationValue,
    tipo,
    setTipo,
  } = FuncionalidadeModel();

  const renderHeader = () => {
    return (
      <div className="modal-push-funcionalidades ">
        <div className="modal-flex-direction-row">
          <img
            alt="imagem"
            className="logo-perguntas"
            src={logoFuncionalidades}
          />
          <h2 className="text-color-branco-titulo">Funcionalidades</h2>
          <div className="div-acoes-perguntas">
            <div className="icons-acoes-perguntas">
              {/* Reordenar Funcionalidades */}
              {/* <img
                alt="Adicionar funcionalidade"
                className="icon-reorder"
                src={IconReorder}
                onClick={() => setTypeScreen(5)}
              /> */}

              <BaSeIcon
                onClick={() => setTypeScreen(2)}
                name="plus-circle"
                description="Adicionar funcionalidade"
                color="#ffffff"
                size={51}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderFiltros = () => {
    return (
      <>
        <div className="filters-content">
          <div
            className="filter-container"
            style={{ borderBottom: '1px solid #cc3467' }}
          >
            <h3
              className="subtitle-funcionalidades"
              // style={{
              //   color: "#cc3467",
              //   marginTop: "2rem",
              //   fontSize: "1.17em",
              //   fontFamily: "Montserrat",
              //   fontWeight: "semibold",
              // }}
            >
              Gerenciar
            </h3>
            <div className="input-content">
              <BaSeInput
                label=""
                iconButton={{
                  name: 'search',
                  type: 'primary-default',
                  typeButton: 'base-icon',
                  value: 'Default',
                  color: '#cc3467',
                }}
                value={filtersSelectedValues?.oqueVoceProcura ?? ''}
                onChange={(value) =>
                  updateSelectedValues('oqueVoceProcura', value)
                }
                placeholder="Digite o que você procura..."
                size="big"
                typeInput="text"
                width="100%"
              />
            </div>
          </div>
        </div>

        <div className="info">
          <div className="results">
            <Accordion style={{ backgroundColor: '#F8F8F8', marginBottom: 20 }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <BaSeIcon
                  name="filter"
                  color="#cc3467"
                  size={25}
                  description="Ícone de filtro"
                  fontWeight="bold"
                />
                <text
                  className="title-accordion"
                  // style={{ color: "#cc3467", fontWeight: "bold" }}
                >
                  Filtrar
                </text>
                <div
                  className="close-filter-container"
                  onClick={(e) => {
                    e.stopPropagation();
                    cleanSelectedFilters();
                    setFilters({ type: 'filters', data: {} });
                  }}
                >
                  <BaSeIcon
                    name="close"
                    size={10}
                    color="#cc3467"
                    description="Limpar filtros"
                  />
                  <text className="title-accordion-component-filter-perguntas">
                    Limpar filtros
                  </text>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="accordionDetails-container-funcionalidades">
                  <div className="content-left">
                    {/* LINHA 1 */}
                    <div className="subContent-menu">
                      <div>
                        <div className="label-style">
                          <label htmlFor="input-menu">Menu</label>
                        </div>
                        <select
                          id="input-menu"
                          value={filtersSelectedValues?.menus ?? ''}
                          className="correct-color"
                          onChange={(event) => {
                            const nome = event.target.value;
                            // const recovery = filterOptions.menus?.find(
                            //   (each) => each.nome === parseInt(nome)
                            // );
                            updateSelectedValues('menus', nome);
                            setFilters({
                              type: 'filters',
                              data: { ...filters.filters, menus: [nome] },
                            });
                          }}
                        >
                          <option value={''}>{DEFAULT_VALUE_SELECIONE}</option>
                          {filterOptions?.menus?.map((menu) => (
                            <option value={menu} title={menu}>
                              {formatDefaultValueSelect(menu)}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <div className="label-style">
                          <label htmlFor="input-parceiro">
                            Parceiro/Provedor
                          </label>
                        </div>
                        <select
                          id="input-parceiro"
                          value={filtersSelectedValues?.parceiros?.id ?? ''}
                          className="correct-color"
                          onChange={(event) => {
                            const id = event.target.value;
                            const recovery = filterOptions.parceiros?.find(
                              (each) => each.id === parseInt(id)
                            );
                            updateSelectedValues('parceiros', recovery);
                            setFilters({
                              type: 'filters',
                              data: {
                                ...filters.filters,
                                parceiros: [recovery],
                              },
                            });
                          }}
                        >
                          <option value={null}>
                            {DEFAULT_VALUE_SELECIONE}
                          </option>
                          {filterOptions.parceiros?.map((par) => (
                            <option value={par.id} title={par.nome}>
                              {formatDefaultValueSelect(par.nome)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* LINHA 2 */}
                    <div className="subContent-data">
                      <div>
                        <div className="label-style">
                          <label htmlFor="input-date">Data</label>
                        </div>
                        <select
                          id="input-date"
                          value={filtersSelectedValues?.tipoAtributoData ?? ''}
                          className="correct-color data-filter-perguntas"
                          onChange={(event) => {
                            const nomeAtributo = event.target.value;
                            const recoveryTipoAtributoData =
                              filterOptions.atributosData.find(
                                (each) => each.nomeAtributo === nomeAtributo
                              );
                            updateSelectedValues(
                              'tipoAtributoData',
                              nomeAtributo
                            );
                            setFilters({
                              type: 'filters',
                              data: {
                                ...filters.filters,
                                tipoAtributoData: recoveryTipoAtributoData,
                              },
                            });
                          }}
                        >
                          <option value={null}>
                            {DEFAULT_VALUE_SELECIONE}
                          </option>
                          {filterOptions?.atributosData?.map((data) => (
                            <option
                              key={data.nomeAtributo}
                              value={data.nomeAtributo}
                              title={data.descricao}
                            >
                              {data.descricao}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="mes-ano-row">
                        <div>
                          <div className="label-style">
                            <label htmlFor="input-mes">Mês</label>
                          </div>
                          <select
                            id="input-mes"
                            value={filtersSelectedValues?.mes ?? ''}
                            className="correct-color mes-filter-perguntas"
                            onChange={(event) => {
                              const mes = event.target.value;
                              updateSelectedValues('mes', mes);
                              setFilters({
                                type: 'filters',
                                data: { ...filters.filters, mes: mes },
                              });
                            }}
                          >
                            <option value={''}>
                              {DEFAULT_VALUE_SELECIONE}
                            </option>
                            {filterOptions?.meses?.map((mes) => (
                              <option value={mes} title={mes}>
                                {formatDefaultValueSelect(mes)}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <div className="label-style">
                            <label htmlFor="input-ano">Ano</label>
                          </div>
                          <select
                            id="input-ano"
                            value={filtersSelectedValues?.ano ?? ''}
                            className="correct-color ano-filter-perguntas"
                            onChange={(event) => {
                              const anos = event.target.value;
                              updateSelectedValues('ano', anos);
                              setFilters({
                                type: 'filters',
                                data: {
                                  ...filters.filters,
                                  ano: parseInt(anos),
                                },
                              });
                            }}
                          >
                            <option value={''}>
                              {DEFAULT_VALUE_SELECIONE}
                            </option>
                            {filterOptions?.anos?.map((anos) => (
                              <option value={anos} title={anos}>
                                {anos}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* TERCEIRA LINHA */}
                    <div className="subContent-ufCidade">
                      <div className="uf-cidade-row">
                        <div className="ufs-area">
                          <div className="label-style">
                            <label htmlFor="input-ufs">UFs</label>
                          </div>

                          <select
                            id="input-ufs"
                            value={filtersSelectedValues?.ufs ?? ''}
                            className="correct-color"
                            onChange={(event) => getCidades(event.target.value)}
                          >
                            <option value={''}>Todas</option>
                            {filterOptions?.ufs?.map((uf) => (
                              <option value={uf.id} title={uf.sigla}>
                                {uf.sigla}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="cidade-area">
                          <div className="label-style">
                            <label htmlFor="input-cidade">Cidade</label>
                          </div>
                          <select
                            id="input-cidade"
                            value={filters.filters?.cidades?.[0]?.id ?? ''}
                            className="correct-color"
                            onChange={(event) => {
                              const id = event.target.value;
                              const recovery = cidades.find(
                                (each) => each.id === parseInt(id)
                              );
                              updateSelectedValues('cidades', recovery);
                              setFilters({
                                type: 'filters',
                                data: {
                                  ...filters.filters,
                                  cidades: [recovery],
                                },
                              });
                            }}
                          >
                            <option value={''}>Todas</option>
                            {cidades.map((cidade) => (
                              <option value={cidade.id} title={cidade.nome}>
                                {cidade.nome}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* TIPO USUÀRIO */}
                      <div className="tipo-user-row">
                        <div className="label-style">
                          <label>Abrangência</label>
                        </div>
                        <div className="inside-user-row">
                          <div className="all-user-row">
                            <input
                              id="label-input-all"
                              type="radio"
                              value={tipo}
                              checked={tipo === 'TODAS'}
                              onChange={() => setTipo('TODAS')}
                            />
                            <label htmlFor="label-input-all">Todos</label>
                          </div>
                          <div className="cpf-user-row">
                            <input
                              id="label-input-cpf"
                              type="radio"
                              value={tipo}
                              checked={tipo === 'PESSOA_FISICA'}
                              onChange={() => setTipo('PESSOA_FISICA')}
                            />
                            <label htmlFor="label-input-cpf">CPF</label>
                          </div>

                          <div className="cnpj-user-row">
                            <input
                              id="label-input-cnpj"
                              type="radio"
                              value={tipo}
                              checked={tipo === 'PESSOA_JURIDICA'}
                              onChange={() => setTipo('PESSOA_JURIDICA')}
                            />
                            <label htmlFor="label-input-cnpj">CNPJ</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="content-right">
                    <div className="plChaves">
                      <div className="label-style">
                        <label htmlFor="input-palavras">Palavras-chave</label>
                      </div>
                      <select
                        value={filtersSelectedValues?.palavrasChave?.id ?? ''}
                        className="correct-color"
                        onChange={(event) => {
                          const palavra = event.target.value;
                          const recovery = filterOptions.palavrasChave?.find(
                            (each) => each.id === parseInt(palavra)
                          );
                          updateSelectedValues('palavrasChave', recovery);
                          setFilters({
                            type: 'filters',
                            data: {
                              ...filters.filters,
                              palavrasChave: [recovery],
                            },
                          });
                        }}
                      >
                        <option value={''}>{DEFAULT_VALUE_SELECIONE}</option>
                        {filterOptions.palavrasChave?.map((pc) => (
                          <option value={pc.id} title={pc.palavra}>
                            {formatDefaultValueSelect(pc.palavra)}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="cpnjOptios">
                      <div className="gridStyle-cpnjOptios">
                        {/* SEGMENTOS */}
                        <div>
                          {tipo === 'PESSOA_JURIDICA' && (
                            <>
                              <label className="label-style">Segmentos</label>
                              <select
                                value={
                                  filtersSelectedValues?.segmentos?.id ?? ''
                                }
                                className="correct-color"
                                onChange={(event) => {
                                  const id = event.target.value;
                                  const recovery =
                                    filterOptions.segmentos?.find(
                                      (each) => each.id === parseInt(id)
                                    );
                                  updateSelectedValues('segmentos', recovery);
                                  setFilters({
                                    type: 'filters',
                                    data: {
                                      ...filters.filters,
                                      segmentos: [recovery],
                                    },
                                  });
                                }}
                              >
                                <option value={null}>
                                  {DEFAULT_VALUE_SELECIONE}
                                </option>
                                {filterOptions.segmentos.map((seg) => (
                                  <option value={seg.id} title={seg.nome}>
                                    {formatDefaultValueSelect(seg.nome)}
                                  </option>
                                ))}
                              </select>
                            </>
                          )}
                        </div>

                        {/* CNAE */}
                        <div>
                          {tipo === 'PESSOA_JURIDICA' && (
                            <>
                              <label className="label-style">CNAE</label>
                              <select
                                value={filtersSelectedValues?.cnaes?.id ?? ''}
                                className="correct-color"
                                onChange={(event) => {
                                  const id = event.target.value;
                                  const recovery = filterOptions.cnaes?.find(
                                    (each) => each.id === parseInt(id)
                                  );
                                  updateSelectedValues('cnaes', recovery);
                                  setFilters({
                                    type: 'filters',
                                    data: {
                                      ...filters.filters,
                                      cnaes: [recovery],
                                    },
                                  });
                                }}
                              >
                                <option value={null}>
                                  {DEFAULT_VALUE_SELECIONE}
                                </option>
                                {filterOptions.cnaes.map((cnae) => (
                                  <option
                                    value={cnae.id}
                                    title={cnae.descricao}
                                  >
                                    {formatDefaultValueSelect(cnae.descricao)}
                                  </option>
                                ))}
                              </select>
                            </>
                          )}
                        </div>

                        {/* PORTE */}
                        <div>
                          {tipo === 'PESSOA_JURIDICA' && (
                            <>
                              <label className="label-style">Porte</label>
                              <select
                                value={filtersSelectedValues?.portes?.id ?? ''}
                                className="correct-color"
                                onChange={(event) => {
                                  const id = event.target.value;
                                  const recovery = filterOptions.portes?.find(
                                    (each) => each.id === parseInt(id)
                                  );
                                  updateSelectedValues('portes', recovery);
                                  setFilters({
                                    type: 'filters',
                                    data: {
                                      ...filters.filters,
                                      portes: [recovery],
                                    },
                                  });
                                }}
                              >
                                <option value={null}>
                                  {DEFAULT_VALUE_SELECIONE}
                                </option>
                                {filterOptions.portes.map((porte) => (
                                  <option
                                    value={porte.id}
                                    title={porte.nomePorte}
                                  >
                                    {formatDefaultValueSelect(porte.nomePorte)}
                                  </option>
                                ))}
                              </select>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
            <div className="attention">
              <div class="info-container">
                <BaSeIcon
                  name="info-circle"
                  size={28}
                  // color="#999999"
                  color="#FF0000"
                  description="Página de gerenciamento"
                />
                {aprovationValue?.PENDENTE > 1 ? (
                  <text>
                    Existem
                    <strong style={{ color: '#FF0000', fontWeight: 'bold' }}>
                      {' '}
                      {aprovationValue?.PENDENTE ?? 0}
                    </strong>{' '}
                    itens aguardando aprovação.
                  </text>
                ) : (
                  <text>
                    Existe
                    <strong style={{ color: '#cc3467', fontWeight: 'bold' }}>
                      {' '}
                      {aprovationValue?.PENDENTE ?? 0}
                    </strong>{' '}
                    item aguardando aprovação.
                  </text>
                )}
              </div>
              <div className="legenda">
                <div
                  className="legenda-buttons"
                  onClick={() => {
                    updateSelectedValues('status', 'APROVADO');
                    setFilters({
                      type: 'filters',
                      data: { ...filters.filters, status: 'APROVADO' },
                    });
                  }}
                >
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9855 0.509766C5.43743 0.509766 0.129883 5.86415 0.129883 12.4705C0.129883 19.0767 5.43743 24.4316 11.9855 24.4316C18.5327 24.4316 23.841 19.0759 23.841 12.4705C23.841 5.86441 18.5327 0.509766 11.9855 0.509766V0.509766ZM11.9855 22.9361C6.25629 22.9361 1.61199 18.2505 1.61199 12.4705C1.61199 6.69053 6.25629 2.00502 11.9855 2.00502C17.7146 2.00502 22.3589 6.69053 22.3589 12.4705C22.3589 18.2505 17.7146 22.9361 11.9855 22.9361V22.9361Z"
                      fill="#33CC66"
                    />
                    <path
                      d="M17.3948 8.27912L9.77144 15.9013L6.59923 12.7646C6.30754 12.4724 5.83327 12.4724 5.54132 12.7646C5.2486 13.0571 5.2486 13.5301 5.54132 13.8216L9.24556 17.4838C9.54933 17.754 10.0036 17.7835 10.3037 17.4838L18.4535 9.33632C18.7455 9.04489 18.7455 8.57082 18.4535 8.27912C18.1611 7.98769 17.6876 7.98769 17.3948 8.27912V8.27912Z"
                      fill="#33CC66"
                    />
                  </svg>

                  {/* <FaCheck size={20} color="#00ff00" /> */}
                  <text className="legenda-text">Aprovado</text>
                </div>
                <div
                  className="legenda-buttons"
                  onClick={() => {
                    updateSelectedValues('status', 'PENDENTE');
                    setFilters({
                      type: 'filters',
                      data: { ...filters.filters, status: 'PENDENTE' },
                    });
                  }}
                >
                  {/* ICON CHECK */}
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9855 0.509766C5.43743 0.509766 0.129883 5.86415 0.129883 12.4705C0.129883 19.0767 5.43743 24.4316 11.9855 24.4316C18.5327 24.4316 23.841 19.0759 23.841 12.4705C23.841 5.86441 18.5327 0.509766 11.9855 0.509766V0.509766ZM11.9855 22.9361C6.25629 22.9361 1.61199 18.2505 1.61199 12.4705C1.61199 6.69053 6.25629 2.00502 11.9855 2.00502C17.7146 2.00502 22.3589 6.69053 22.3589 12.4705C22.3589 18.2505 17.7146 22.9361 11.9855 22.9361V22.9361Z"
                      fill="#ff0000"
                    />
                    <path
                      d="M17.3948 8.27912L9.77144 15.9013L6.59923 12.7646C6.30754 12.4724 5.83327 12.4724 5.54132 12.7646C5.2486 13.0571 5.2486 13.5301 5.54132 13.8216L9.24556 17.4838C9.54933 17.754 10.0036 17.7835 10.3037 17.4838L18.4535 9.33632C18.7455 9.04489 18.7455 8.57082 18.4535 8.27912C18.1611 7.98769 17.6876 7.98769 17.3948 8.27912V8.27912Z"
                      fill="#ff0000"
                    />
                  </svg>

                  {/* <FaCheck size={20} color="#ff0000" /> */}
                  <text>Aguardando aprovação</text>
                </div>
              </div>
            </div>

            <div className="flex container-excel-icon">
              <div>
                {/* <p className="text-color-azul-ref margin-bottom-20 ">
                  Ref:{" "}
                  {time && `${time.split(" ")[0]} às ${time.split(" ")[1]}`}
                </p> */}
                <p className="text-color-perguntas text-resultsFind-funcionalidades">
                  {data?.totalElements ?? 0}
                  <strong className="find-results">
                    {' '}
                    resultados encontrados{' '}
                  </strong>
                </p>
              </div>

              {!downloadedSheet && !downloadingSheet && (
                <img
                  className="xls"
                  alt="imagem"
                  src={download}
                  onClick={downloadFile}
                  style={{ width: '3.1rem' }}
                />
              )}
              {!downloadedSheet && downloadingSheet && (
                // <div className="loader"></div>
                <Spinner
                  radius={40}
                  color={'#33cc99'}
                  stroke={2}
                  visible={true}
                />
              )}
              {/*{downloadedSheet && (*/}
              {/*  <ExcelFile*/}
              {/*    filename={`Funcionalidades-${formatDateToBR(new Date())}`}*/}
              {/*    element={*/}
              {/*      <img*/}
              {/*        className="xls"*/}
              {/*        alt="imagem"*/}
              {/*        src={xlsImagem}*/}
              {/*        style={{ width: '3.1rem' }}*/}
              {/*      />*/}
              {/*    }*/}
              {/*  >*/}
              {/*    <ExcelSheet data={trateExcelData()} name="Values">*/}
              {/*      {tratedCols.map((col) => (*/}
              {/*        <ExcelColumn label={col.label} value={col.field} />*/}
              {/*      ))}*/}
              {/*    </ExcelSheet>*/}
              {/*  </ExcelFile>*/}
              {/*)}*/}
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderDefault = (value, column) => {
    return (
      <TableCell
        key={column.id}
        align={column.align}
        style={{
          maxWidth: column.maxWidth,
          overflowWrap: column.overflowWrap,
        }}
      >
        <p className="text-table-servicos">{value}</p>
      </TableCell>
    );
  };

  const handleActionClick = ({
    title,
    content,
    actionTitle,
    titleSuccess,
    msgSuccess,
    titleError,
    msgError,
    reloadPage,
  }) => {
    const Sim = 'Ok';
    const Nao = 'Não';

    const actions = {
      [Sim]: async () => {
        const response = await actionTitle();
        const innerActions = {
          [Sim]: () => console.log('Fechado'),
        };

        let configReturn;
        if (response.status === 200) {
          configReturn = {
            // Entradas
            actions: [
              {
                action: Sim,
                type: 'primary',
                color: BaSeTheme.colors.feedbackInterface.sucesso20,
              },
            ],
            title: titleSuccess,
            titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45, // Quando não passar, assume-se o valor #617385
            dismissable: true, // Quando não passar, assume-se o valor `true`
            content: () => <>{msgSuccess()}</>,
            onOpen: () => console.log('>>> Abriu a modal'),
            onChooseAction: (action) => innerActions?.[action]?.(),
            onDismiss: () =>
              console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
            afterClose: () => console.log('>>> Modal fechada'),
          };

          if (reloadPage) setActionDone(true);
        } else {
          configReturn = {
            // Entradas
            actions: [
              {
                action: Sim,
                type: 'primary',
                color: BaSeTheme.colors.feedbackInterface.sucesso20,
              },
            ],
            title: titleError,
            titleColor: BaSeTheme.colors.institucionais.erro45, // Quando não passar, assume-se o valor #617385
            dismissable: true, // Quando não passar, assume-se o valor `true`
            content: () => <>{msgError()}</>,
            onOpen: () => console.log('>>> Abriu a modal'),
            onChooseAction: (action) => innerActions?.[action]?.(),
            onDismiss: () =>
              console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
            afterClose: () => console.log('>>> Modal fechada'),
          };
        }

        showModal(configReturn);
      },
    };

    const config = {
      // Entradas
      actions: [
        {
          action: Sim,
          type: 'primary',
          color: BaSeTheme.colors.feedbackInterface.sucesso20,
        },
        {
          action: Nao,
          type: 'primary',
          color: BaSeTheme.colors.feedbackInterface.erro45,
        },
      ],
      title: title,
      titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45, // Quando não passar, assume-se o valor #617385
      dismissable: true, // Quando não passar, assume-se o valor `true`
      content: () => <>{content()}</>,
      onOpen: () => console.log('>>> Abriu a modal'),
      onChooseAction: (action) => actions?.[action]?.(),
      onDismiss: () =>
        console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
      afterClose: () => console.log('>>> Modal fechada'),
    };

    showModal(config);
  };

  const renderActions = (column, row) => {
    return (
      <TableCell align={column.align} style={{ maxWidth: column.maxWidth }}>
        <div className="itens-actions">
          {/* APROVE ICON SVG */}
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() =>
              handleActionClick({
                content: () => {
                  return (
                    <text>
                      Ao{' '}
                      <strong>
                        {row.status !== 'APROVADO' ? 'APROVAR' : 'DESAPROVAR'}
                      </strong>
                      {row.status !== 'APROVADO'
                        ? ' esta funcionalidade, ela será apresentada no app. Deseja continuar?'
                        : ' esta funcionalidade, ela deixará de ser apresentada no app. Deseja continuar?'}
                    </text>
                  );
                },
                title: row.status === 'APROVADO' ? 'Desaprovar' : 'Aprovar',
                actionTitle: () =>
                  updateStatusFuncionalidade(
                    row.id,
                    row.status !== 'APROVADO' ? 'APROVADO' : 'PENDENTE'
                  ),
                titleSuccess: 'Sucesso',
                msgSuccess: () => (
                  <text>
                    A funcionalidade foi{' '}
                    <strong>
                      {row.status !== 'APROVADO' ? 'aprovada ' : 'desaprovada '}
                    </strong>
                    com sucesso.
                  </text>
                ),
                titleError: 'Erro.',
                msgError: () => (
                  <text>
                    A funcionalidade não foi{' '}
                    <strong>
                      {row.status !== 'APROVADO' ? 'aprovada' : 'desaprovada'}
                    </strong>
                    .Sistema temporariamente fora do ar. Tente novamente mais
                    tarde.
                  </text>
                ),
                reloadPage: true,
              })
            }
          >
            <path
              d="M11.9855 0.509766C5.43743 0.509766 0.129883 5.86415 0.129883 12.4705C0.129883 19.0767 5.43743 24.4316 11.9855 24.4316C18.5327 24.4316 23.841 19.0759 23.841 12.4705C23.841 5.86441 18.5327 0.509766 11.9855 0.509766V0.509766ZM11.9855 22.9361C6.25629 22.9361 1.61199 18.2505 1.61199 12.4705C1.61199 6.69053 6.25629 2.00502 11.9855 2.00502C17.7146 2.00502 22.3589 6.69053 22.3589 12.4705C22.3589 18.2505 17.7146 22.9361 11.9855 22.9361Z"
              fill={row.status === 'APROVADO' ? '#33CC66' : '#ff0000'}
            />
            <path
              d="M17.3948 8.27912L9.77144 15.9013L6.59923 12.7646C6.30754 12.4724 5.83327 12.4724 5.54132 12.7646C5.2486 13.0571 5.2486 13.5301 5.54132 13.8216L9.24556 17.4838C9.54933 17.754 10.0036 17.7835 10.3037 17.4838L18.4535 9.33632C18.7455 9.04489 18.7455 8.57082 18.4535 8.27912C18.1611 7.98769 17.6876 7.98769 17.3948 8.27912Z"
              fill={row.status === 'APROVADO' ? '#33CC66' : '#ff0000'}
            />
          </svg>

          {/* EDIT ICON SVG */}
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => {
              setTypeScreen(3);
              setSelectedRow(row);
            }}
          >
            <path
              d="M12.2887 0.509766C5.74065 0.509766 0.433105 5.86415 0.433105 12.4705C0.433105 19.0767 5.74065 24.4316 12.2887 24.4316C18.8357 24.4316 24.1442 19.0759 24.1442 12.4705C24.1442 5.86441 18.8357 0.509766 12.2887 0.509766V0.509766ZM12.2887 22.9361C6.55951 22.9361 1.91521 18.2505 1.91521 12.4705C1.91521 6.69053 6.55951 2.00502 12.2887 2.00502C18.0178 2.00502 22.6621 6.69053 22.6621 12.4705C22.6621 18.2505 18.0176 22.9361 12.2887 22.9361Z"
              fill="#B3B3B3"
            />
            <path
              d="M17.3821 9.22918L16.9595 9.65558L15.0776 7.75671L15.5002 7.33031C15.7213 7.10727 16.0811 7.10727 16.3024 7.33031L17.3821 8.41989C17.6037 8.64345 17.6037 9.00535 17.3821 9.22918ZM7.44186 15.9099L8.87903 17.3598L7.11525 17.6894L7.44186 15.9099ZM9.59518 17.086L7.71328 15.1872L14.5841 8.25487L16.466 10.1537L9.59518 17.086ZM17.8759 7.92199L16.7962 6.83241C16.3027 6.33451 15.5 6.33451 15.0067 6.83241C14.5422 7.30104 7.447 14.4597 6.97299 14.9382C6.92241 14.9892 6.88877 15.0568 6.87644 15.1232L6.33645 18.065C6.3154 18.179 6.3516 18.2961 6.43274 18.3782C6.51414 18.4603 6.63046 18.4966 6.74318 18.4756L9.65861 17.9308C9.72614 17.9181 9.79213 17.8836 9.84194 17.8336L17.8759 9.72785C18.3705 9.22892 18.3705 8.42145 17.8759 7.92251V7.92199Z"
              fill="#B3B3B3"
              stroke="#B3B3B3"
              strokeWidth="0.352772"
              strokeMiterlimit="10"
            />
          </svg>

          {/* DELETE ICON SVG  */}
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() =>
              handleActionClick({
                content: () => (
                  <text>
                    Ao <strong>excluir</strong> esta funcionalidade, ela deixará
                    de ser apresentada no App. Deseja continuar?
                  </text>
                ),
                title: 'Apagar',
                actionTitle: () => deleteFuncionalidade(row.id),
                titleSuccess: 'Sucesso',
                msgSuccess: () => (
                  <text>
                    A funcionalidade foi <strong>excluída</strong> com sucesso.
                  </text>
                ),
                titleError: 'Erro.',
                msgError: () => (
                  <text>
                    A funcionalidade <strong> não foi excluída</strong>.
                    Aconteceu um erro ou o sistema temporariamente fora do ar.
                    Tente novamente mais tarde.
                  </text>
                ),
                reloadPage: true,
              })
            }
          >
            <path
              d="M12.5895 0.866211C6.04143 0.866211 0.733887 6.22085 0.733887 12.827C0.733887 19.4331 6.04143 24.7878 12.5895 24.7878C19.1367 24.7878 24.445 19.4323 24.445 12.827C24.445 6.22085 19.1367 0.866211 12.5895 0.866211ZM12.5895 23.2925C6.86029 23.2925 2.21599 18.607 2.21599 12.827C2.21599 7.04698 6.86029 2.36147 12.5895 2.36147C18.3186 2.36147 22.9629 7.04698 22.9629 12.827C22.9629 18.607 18.3186 23.2925 12.5895 23.2925Z"
              fill="#B3B3B3"
            />
            <path
              d="M17.5737 9.40112L17.3023 8.58122C17.1991 8.2688 16.9105 8.05922 16.5841 8.05922H14.3052V7.31056C14.3052 6.93622 14.0038 6.63184 13.633 6.63184H11.5459C11.1754 6.63184 10.8737 6.93622 10.8737 7.31056V8.05922H8.59478C8.26842 8.05922 7.97981 8.26906 7.87659 8.58122L7.60543 9.40112C7.54355 9.5879 7.57487 9.79462 7.68888 9.9542C7.80289 10.1138 7.98751 10.2094 8.1824 10.2094H8.46588L9.08959 17.9916C9.13607 18.569 9.62188 19.0213 10.1958 19.0213H15.1094C15.6831 19.0213 16.1691 18.569 16.2154 17.9913L16.8391 10.2091H16.996C17.1909 10.2091 17.3755 10.1138 17.4895 9.9542C17.6035 9.79462 17.6348 9.58764 17.5732 9.40086L17.5737 9.40112ZM11.5937 7.3577H13.586V8.05896H11.5937V7.3577ZM15.4984 17.9331C15.4823 18.1364 15.3115 18.2955 15.1099 18.2955H10.1963C9.99472 18.2955 9.82397 18.1364 9.80753 17.9331L9.18845 10.2094H16.1178L15.4987 17.9331H15.4984ZM8.33724 9.48324L8.5596 8.81074C8.56474 8.79519 8.57912 8.78483 8.5953 8.78483H16.5843C16.6005 8.78483 16.6149 8.79519 16.62 8.81074L16.8424 9.48324H8.3375H8.33724Z"
              fill="#B3B3B3"
              stroke="#B3B3B3"
              strokeWidth="0.306946"
              strokeMiterlimit="10"
            />
            <path
              d="M14.3513 17.9072C14.3577 17.9075 14.3639 17.9077 14.3703 17.9077C14.5605 17.9077 14.7196 17.7575 14.7296 17.5637L15.0678 11.0205C15.0781 10.8203 14.9254 10.6496 14.7268 10.6392C14.5276 10.6283 14.3587 10.7825 14.3485 10.9827L14.0103 17.5259C14 17.7261 14.1524 17.8969 14.3513 17.9072Z"
              fill="#B3B3B3"
              stroke="#B3B3B3"
              strokeWidth="0.306946"
              strokeMiterlimit="10"
            />
            <path
              d="M10.4667 17.5645C10.477 17.758 10.6361 17.9077 10.826 17.9077C10.8324 17.9077 10.8394 17.9075 10.8458 17.9072C11.0445 17.8964 11.1966 17.7254 11.1858 17.5251L10.8317 10.9819C10.8209 10.7817 10.651 10.6283 10.4524 10.6392C10.254 10.6501 10.1016 10.8213 10.1124 11.0213L10.4665 17.5645H10.4667Z"
              fill="#B3B3B3"
              stroke="#B3B3B3"
              strokeWidth="0.306946"
              strokeMiterlimit="10"
            />
            <path
              d="M12.5939 17.9077C12.7928 17.9077 12.954 17.7453 12.954 17.5448V11.0016C12.954 10.8011 12.7928 10.6387 12.5939 10.6387C12.395 10.6387 12.2339 10.8011 12.2339 11.0016V17.5448C12.2339 17.7453 12.395 17.9077 12.5939 17.9077Z"
              fill="#B3B3B3"
              stroke="#B3B3B3"
              strokeWidth="0.306946"
              strokeMiterlimit="10"
            />
          </svg>
        </div>
      </TableCell>
    );
  };

  const renderTable = () => {
    return (
      <div className="table-wrapper">
        {isLoading && <text>Carregando...</text>}
        {!isLoading && (
          <Table>
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  const nameIcon = column.subfield
                    ? `${column.field}.${column.subfield}`
                    : column.field;
                  return (
                    <TableCell
                      className="table-relatorio-perguntas"
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        overflowWrap: 'break-word',
                      }}
                    >
                      <div className="table-cell-container">
                        <p style={{ color: '#cc3467', fontWeight: 'bold' }}>
                          {column.label}
                        </p>
                        {column.id !== 'status' && (
                          <BaSeIcon
                            name={
                              filters.order.name === nameIcon &&
                              filters.order.orderType
                                ? 'angle-up'
                                : 'angle-down'
                            }
                            color="#cc3467"
                            size={24}
                            description="Botão de ordenação"
                            onClick={() =>
                              setFilters({
                                type: 'order',
                                data: {
                                  name: nameIcon,
                                  orderType:
                                    nameIcon === filters.order.name
                                      ? !filters.order.orderType
                                      : true,
                                },
                              })
                            }
                          />
                        )}
                      </div>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {console.log('data', data)} */}
              {data?.content &&
                data.content.map((row, index) => (
                  <TableRow
                    style={{
                      backgroundColor: index % 2 === 0 ? '#fff' : '#cc34671A',
                    }}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={index}
                  >
                    {columns.map((column) => {
                      const { id } = column;
                      const value = row[id];

                      if (id !== 'status') {
                        const finalValue = Array.isArray(value)
                          ? value
                              .map(
                                (elem) =>
                                  elem.sigla ??
                                  formatDefaultValueSelect(elem.palavra)
                              )
                              .join()
                          : value?.sigla ?? value?.nome ?? row[id];

                        return renderDefault(
                          column.id === 'dataCriacao'
                            ? formatDateToBR(value)
                            : formatDefaultValueSelect(finalValue),
                          column
                        );
                      } else {
                        return renderActions(column, row);
                      }
                    })}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}

        <div className="pagination-container-funcionalidades">
          <div>
            <label>Linhas por página:</label>
            <select
              style={{ color: '#cc3467' }}
              value={filters.linesPerPage}
              onChange={(e) =>
                setFilters({ type: 'linesPerPage', data: e.target.value })
              }
            >
              {optionsLinesPorPage.map((olp) => (
                <option value={olp}>{olp}</option>
              ))}
            </select>
          </div>

          <div className="icons-wrapper page-selector">
            <FaArrowCircleLeft
              color={filters.page === 0 ? '#b4b3b6' : '#cc3467'}
              onClick={() => {
                if (filters.page !== 0) {
                  setFilters({ type: 'page', data: filters.page - 1 });
                  updateSelectedValues(
                    'page',
                    parseInt(filtersSelectedValues?.page) - 1
                  );
                }
              }}
              size={24}
            />
            <FaArrowCircleRight
              color={
                data.totalPages === 0 || filters.page === data.totalPages - 1
                  ? '#b4b3b6'
                  : '#cc3467'
              }
              onClick={() => {
                if (
                  data.totalPages !== 0 &&
                  filters.page !== data.totalPages - 1
                ) {
                  setFilters({ type: 'page', data: filters.page + 1 });
                  updateSelectedValues(
                    'page',
                    parseInt(filtersSelectedValues?.page) + 1
                  );
                }
              }}
              size={24}
            />
          </div>

          <div className="pagination-container-numbers-funcionalidades">
            <input
              value={filtersSelectedValues?.page ?? '1'}
              type="number"
              className="input-page"
              style={{ color: '#cc3467' }}
              onChange={(event) => {
                const { value } = event.target;
                const numberValue = parseInt(value);
                if (
                  value === '' ||
                  (numberValue && value > 0 && numberValue <= data.totalPages)
                )
                  updateSelectedValues('page', value);
              }}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  if (filtersSelectedValues?.page !== '') {
                    setFilters({
                      type: 'page',
                      data: parseInt(filtersSelectedValues?.page)
                        ? filtersSelectedValues?.page - 1
                        : 0,
                    });
                  } else {
                    setFilters({ type: 'page', data: 0 });
                    updateSelectedValues('page', '1');
                  }
                }
              }}
            />
            <text
              style={{
                fontSize: 12,
                marginLeft: 5,
                marginTop: '0.4rem',
                color: '#b4b3b6',
              }}
            >
              de {data.totalPages}
            </text>
          </div>
        </div>
      </div>
    );
  };

  const renderListPage = () => {
    return (
      <div className="container-principal">
        {renderHeader()}
        {renderFiltros()}
        {renderTable()}
      </div>
    );
  };

  return (
    <>
      {error && <BaSeBackendNoSignalPage />}
      {!error && typeScreen === 1 && renderListPage()}
      {!error &&
        !isLoading &&
        (typeScreen === 2 || typeScreen === 3 || typeScreen === 4) && (
          <AddFuncionalidade
            namePage="Adicionar"
            onClose={() => {
              setTypeScreen(1);
              setActionDone(true);
            }}
            mainColor="#CC3467"
            selectedRow={selectedRow}
            allValuesOptions={allValuesOptions}
            setAllValuesOptions={(options) => setAllValuesOptions(options)}
            typeScreen={typeScreen}
          />
        )}
      {!error && !isLoading && typeScreen === 5 && (
        <ReorderFuncionalidades
          data={data}
          tipos={allValuesOptions?.assuntos ?? []}
          setAllValuesOptions={setAllValuesOptions}
          setActionDone={setActionDone}
          onClose={() => {
            setTypeScreen(1);
            setActionDone(true);
          }}
        />
      )}
    </>
  );
};

export default Funcionalidades;
